<card [fullScreen]="state.isFullScreen">
  <span header-title>{{'cards.clients.clients_list.title' | translate}}</span>
  <div header-actions>
    <div class="filters flex">
      <filter-select
        class="mr30"
        label="cards.clients.clients_list.label.status"
        [formGroup]="controls"
        [options]="statusOptions"
        [sortByLabel]="true"
        for="statusFilter"
        [clearable]="false"
        value="id"
      ></filter-select>

      <filter-select
        label="cards.clients.clients_list.label.client_type"
        [formGroup]="controls"
        [options]="filterTypeOptions"
        for="listFilterType"
        [clearable]="false"
        value="id"
        labelField="label"
      ></filter-select>
    </div>

    <lxm-button
      type="beige"
      label="cards.clients.clients_list.actions.add_client"
      icon="plus-dark"
      routerLink="new"
      *requiredRights="[UserAction.ManageClients]"
    >
    </lxm-button>
  </div>
  <div body class="sticky-table">
    <div class="sticky-table-body overflow-x w-full">
      <mat-table
        [dataSource]="dataSource"
        matSort
        [@.disabled]="true"
        [zoomValue]="state.zoom"
      >
        <ng-container matColumnDef="client_image">
          <mat-header-cell *matHeaderCellDef></mat-header-cell>
          <mat-cell *matCellDef="let row">
            <image-popover
              type="regular"
              [popperPositionFixed]="false"
              [status]="row.status"
              imageUrl="clients/{{row.id}}/logo/withDefaultImageFallback"
            >
            </image-popover>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="client_name">
          <mat-header-cell *matHeaderCellDef>
            <span mat-sort-header>
              {{'cards.clients.clients_list.table.client_name' | translate}}
            </span>
          </mat-header-cell>
          <mat-cell *matCellDef="let row">
            <div class="triple-rows">
              <span class="cell-row overflow-ellipsis"> {{row.name}} </span>
              <span class="cell-row alt-text">{{row.address}}</span>
            </div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="client_tags">
          <mat-header-cell *matHeaderCellDef>
            <span>
              {{'cards.clients.clients_list.table.client_tags' | translate}}
            </span>
          </mat-header-cell>
          <mat-cell *matCellDef="let row">
            <span class="flex">
              <span
                [class]="getTagClass(tagId)"
                *ngFor="let tagId of limitTags(row)"
              >
                {{clientTagsById[tagId]?.value}}
              </span>
              <span
                class="client-tag-extra-items"
                [popper]="tagsTooltipContent"
                popperTrigger="hover"
                popperPlacement="right"
                [popperPositionFixed]="true"
                popperAppendTo="app-root"
                [popperHideOnMouseLeave]="true"
                *ngIf="row.clientTagIds?.length > 2"
              >
                +{{row.clientTagIds.length - 2}}
              </span>
              <popper-content #tagsTooltipContent stop-propagation>
                <div>
                  <span
                    [class]="getTagClass(tagId)"
                    *ngFor="let tagId of row.clientTagIds"
                  >
                    {{clientTagsById[tagId]?.value}}
                  </span>
                </div>
              </popper-content>
            </span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="client_reg_code">
          <mat-header-cell *matHeaderCellDef>
            <span mat-sort-header>
              {{'cards.clients.clients_list.table.reg_code' | translate}}
            </span>
          </mat-header-cell>
          <mat-cell *matCellDef="let row">
            <div class="triple-rows">
              <div class="cell-row client-reg-no">
                <span class="client-reg-no-text">{{row.regNo || '-'}}</span>
                <lxm-animated-button
                  *ngIf="row.regNo"
                  icon="!w-7x !h-7x copy"
                  clickedIcon="success"
                  title="cards.clients.clients_list.actions.copy_code"
                  clickedTitle="cards.clients.clients_list.actions.copy_code_success"
                  (click)="copyCode($event, row.regNo)"
                ></lxm-animated-button>
              </div>
              <div class="cell-row client-reg-no">
                <span class="client-reg-no-text">{{row.vatNo || '-'}}</span>
                <lxm-animated-button
                  *ngIf="row.vatNo"
                  icon="!w-7x !h-7x copy"
                  clickedIcon="success"
                  title="cards.clients.clients_list.actions.copy_code"
                  clickedTitle="cards.clients.clients_list.actions.copy_code_success"
                  (click)="copyCode($event, row.vatNo)"
                ></lxm-animated-button>
              </div>
            </div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="client_address">
          <mat-header-cell *matHeaderCellDef>
            <span mat-sort-header class="f-1 flex justify-start">
              {{'cards.clients.clients_list.table.address' | translate}}
            </span>
          </mat-header-cell>
          <mat-cell *matCellDef="let row">
            <span>{{row.address || '-'}}</span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="client_is_retailer">
          <mat-header-cell *matHeaderCellDef>
            <span mat-sort-header class="f-1 flex justify-center">
              {{'cards.clients.clients_list.table.retailer' | translate}}
            </span>
          </mat-header-cell>
          <mat-cell *matCellDef="let row">
            <div class="f-1 flex justify-center">
              <span
                [class.accept-green-icon]="row.isSystemClient"
                [class.x-grey-icon]="!row.isSystemClient"
              ></span>
            </div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="client_is_store_client">
          <mat-header-cell *matHeaderCellDef>
            <span mat-sort-header class="f-1 flex justify-center">
              {{'cards.clients.clients_list.table.store_client' | translate}}
            </span>
          </mat-header-cell>
          <mat-cell *matCellDef="let row">
            <div class="f-1 flex justify-center">
              <span
                [class.accept-green-icon]="row.isStoreClient"
                [class.x-grey-icon]="!row.isStoreClient"
              ></span>
            </div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="upcoming_event">
          <mat-header-cell *matHeaderCellDef>
            <span mat-sort-header class="cell-center">
              {{'cards.clients.clients_list.table.upcoming_event' | translate}}
            </span>
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="cell-center">
            {{row.upcomingEventDate ? (row.upcomingEventDate | formDate) : ''}}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="client_visible_in_products_list">
          <mat-header-cell *matHeaderCellDef>
            <div class="flex flex-1" mat-sort-header>
              <span class="text-center">
                {{'cards.clients.clients_list.table.visible_in_products_list' |
                translate}}
              </span>
              <description-popover
                class="mt3"
                [readonly]="readonly"
                description="{{ 'cards.clients.clients_list.table.visible_in_products_list_tooltip' | translate }}"
              ></description-popover>
            </div>
          </mat-header-cell>
          <mat-cell *matCellDef="let row" stop-propagation class="cell-center">
            <div
              class="f-1 flex justify-center"
              class="no-click"
              [formGroup]="createRowFormGroup(row)"
            >
              <slide-toggle for="visibleInProductsList"></slide-toggle>
            </div>
          </mat-cell>
        </ng-container>

        <mat-header-row
          *matHeaderRowDef="table.columns"
          class="products-table-head"
        ></mat-header-row>
        <mat-row
          *matRowDef="let row; columns: table.columns;"
          class="table-row-hover"
          routerLink="/clients/{{row.id}}"
        ></mat-row>
      </mat-table>
    </div>

    <no-content
      heading="cards.clients.clients_list.no_clients_heading"
      text="cards.clients.clients_list.no_clients_text"
      image="no-clients"
      *ngIf="!hasClients"
    >
    </no-content>

    <data-table-footer
      [(zoom)]="state.zoom"
      [(isFullScreen)]="state.isFullScreen"
      (onToggleFullScreen)="state.isFullScreen = $event"
      [localStorageKey]="LOCAL_STORAGE_KEY"
      (paginator)="hookPaginator($event)"
      [search]="search"
      (onSearch)="onSearch($event)"
      (onLoad)="onLoad()"
    >
    </data-table-footer>
  </div>
</card>
